import { Component, Input } from '@angular/core';
import { NumberFormatOptions } from '@progress/kendo-angular-intl';
import { Constants } from '@/constants';
import { PaymentService } from '@/core/services/payment.service';

@Component({
    selector: 'app-pending-amounts',
    templateUrl: './pending-amounts.component.html',
    styleUrls: ['./pending-amounts.component.scss']
})
export class PendingAmountsComponent {
    @Input()
    public showFoerdersummeOffen: boolean = false;

    public currencyFormatOptions: NumberFormatOptions = Constants.CURRENCY_FORMAT_OPTIONS;

    constructor(protected paymentService: PaymentService) {
    }
}